import type { DocMigration } from "../docMigration";

function replaceZeroWithUndefined(elevationAnnotationParams: any) {
  if (elevationAnnotationParams.levelAnnotationOffset === 0) {
    delete elevationAnnotationParams.levelAnnotationOffset;
  }
  if (elevationAnnotationParams.levelAnnotationVerticalSpacing === 0) {
    delete elevationAnnotationParams.levelAnnotationVerticalSpacing;
  }
}

const migration: DocMigration = {
  id: "20251222_elevation_anno_params_zero_is_undefined",
  description: "Replace 0 with undefined in elevationAnnotationParams",
  apply(json: any) {
    // traverse viewports
    for (const id in json.viewports) {
      const viewport = json.viewports[id];
      if (viewport.viewType === "ELEVATION_VIEW" && viewport.elevationAnnotationParams) {
        replaceZeroWithUndefined(viewport.elevationAnnotationParams);
      }
    }
    // traverse elevationViews
    for (const id in json.elevationViews) {
      const elevationView = json.elevationViews[id];
      if (elevationView.elevationAnnotationParams) {
        replaceZeroWithUndefined(elevationView.elevationAnnotationParams);
      }
    }
    return json;
  },
};

export default migration;
